import 'tinymce/plugins/paste';
export const MCE_PASTE = 'paste';